import { MessageCircle } from 'lucide-react';
import type { PersonnePrevenue } from '../../types';
import { listePrevenus } from './format';

/**
 * Fiche d'une demande (onglet Recherche), pour la gestion, la personne absente et l'auteur·rice SEULEMENT (le serveur ne renvoie
 * `prevenus` à personne d'autre) : les collègues prévenu·e·s par un message personnel, EN PLUS du message Slack pour tout le monde (dont l'état est
 * dit plus bas : préparé, publié…). « Pas de compte : pas de message » : on le dit, pour qu'on sache qu'il faut la/le contacter autrement.
 * `rechercheLancee` : la recherche a démarré — un message encore « en attente » n'est alors PAS parti (rien ne le renverra tout seul).
 */
export function PrevenusPersonnellement({ prevenus, rechercheLancee = false }: { prevenus: PersonnePrevenue[]; rechercheLancee?: boolean }) {
  if (prevenus.length === 0) return null;
  return (
    <div className="prevenus-perso">
      <MessageCircle size={16} aria-hidden="true" />
      <div>
        <span className="prevenus-perso-t">Prévenu·e·s personnellement : </span>
        <span>{listePrevenus(prevenus, rechercheLancee)}</span>
        <div className="text-xs text-ink-3">En plus du message Slack pour tou·te·s. Seules les personnes ayant un compte reçoivent le message.</div>
      </div>
    </div>
  );
}
